module.exports = __webpack_public_path__ + "img/emo_32.953254a5.png";